import { FC, useMemo } from "react";

const UTMFields: FC<{values: { [key: string]: any}}> = ({ values }) => {
    const utmValues = useMemo(() => Object.entries(values).reduce((acc, [key, value]) => {
        if (key.startsWith('utm_')) {
            acc[key] = value;
        }
        return acc;
    }, {}), [values])

    return (
        <>
            {Object.entries(utmValues).map(([key, value]) => (
                <input type="hidden" key={key} name={key} value={`${value}`} />
            ))}
        </>
    )};
export default UTMFields;